window.addEventListener('load', () => {
    const pageLink = document.getElementById('hit-count__pages');
    const allLink = document.getElementById('hit-count__all');
    const pageItems = document.querySelectorAll('.other-hits__list-page__item[data-tag="Page"]');
    const allItems = document.querySelectorAll('.other-hits__list-page__item');
    const tagBtns = document.querySelectorAll('.hit-count__container__content');

    if (pageLink) {
        pageLink.addEventListener('click', function () {
            if (allItems.length > 0) {
                allItems.forEach(function (item) {
                    item.classList.add("hit-count__hide");
                });
            }
            if (pageItems.length > 0) {
                pageItems.forEach(function (item) {
                    item.classList.remove("hit-count__hide");
                });
            }
        });
    }

    if (allLink) {
        allLink.addEventListener('click', function () {
            if (allItems.length > 0) {
                allItems.forEach(function (item) {
                    item.classList.remove("hit-count__hide");
                });
            }
        });
    }

    tagBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            tagBtns.forEach(function (otherBtn) {
                if (btn !== otherBtn) {
                    otherBtn.classList.remove('hit-count__tag-button-active');
                }
            });
            btn.classList.add('hit-count__tag-button-active');
        });
    });
});